
export const lastInteractionMethod = { current: 'mouse' };

export function setupInteractionListeners() {
  window.addEventListener('keydown', () => {
    lastInteractionMethod.current = 'keyboard';
  });
  window.addEventListener('mousedown', () => {
    lastInteractionMethod.current = 'mouse';
  });
}